import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  Renderer2,
} from '@angular/core';
import {
  HelperService,
  AppSettings,
  AuthenticationService,
  Getunitdetails,
  Agents,
} from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-un-paid-order',
  templateUrl: './un-paid-order.component.html',
  styleUrls: ['./un-paid-order.component.css'],
})
export class UnPaidOrderComponent implements OnInit {
  public orderStatus: any = AppSettings.orderStatus;
  public despositionArray: any;

  public dispFirstEle: any;
  public documentTypeArray: any = AppSettings.documentType;
  public siteList: any = AppSettings.siteList;

  public loading: any = false;
  public paginatePage: any;
  public leads: any = [];
  public leads_Copy: any = [];
  public comments: any = [];
  public agentComments: any = [];
  public qaComments: any = [];
  public unpaidComments: any = [];
  public agentsSub: any;
  public select2Agents: any = [];
  public agents: any;
  public qa: any;
  public loader: any;
  public qaloader: any;
  public uploader: any;
  public checkedClass: any = false;
  public activeUser: any;
  public lead_Index: any = null;
  public notes: any = '';
  public notesInfo: any;
  public addCommentForm: FormGroup;
  public submitted: any = false;
  public showprice: any;
  public menuBtnClick: any = false;
  public floatingAlert: any = false;
  public salesIndex: any = null;
  public salesStatusVal: any = null;

  public many_orders_detail: any = {
    first_paid_order_date: '',
    first_unpaid_order_date: '',
    last_paid_order_date: '',
    last_unpaid_order_date: '',
    paid_orders_value: 0,
    total_paid_orders: 0,
    total_unpaid_orders: 0,
    unpaid_orders_value: 0,
  };

  public verifiedStatuses: any = [
    {
      name: 'Verified',
      value: 1,
    },
    {
      name: 'Un-verified',
      value: 0,
    },
  ];
  public isMyTab: any = false;
  intervals: { [leadId: number]: any } = {};
  hoveredIndex: number | null = null;
  clickedIndex: number | null = null;
  countdowns: { [key: string]: string } = {};
  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: any = new Subject();

  public searchParams: any = {
    emailId: '',
    site_link: null,
    disposition: null,
    agent_id: [],
    date_from: '',
    date_to: '',
    work_type: null,
    valid_sales: null,
    is_paid: null,
  };
  public fullRangeDate: string[] = this.getDateRange();
  private getDateRange(): string[] {
    // Get current date/time in America/Los_Angeles
    const nowInLA = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })
    );
    console.log('Los Angeles current time:', nowInLA);
    // Set time to 00:00:00 for consistency (optional)
    nowInLA.setHours(0, 0, 0, 0);

    const formatDate = (date: Date): string => {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    };

    // Return the same date twice (start and end)
    return [formatDate(nowInLA), formatDate(nowInLA)];
  }

  constructor(
    private helperService: HelperService,
    private agentsService: Agents,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    // toggle price input
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.menuBtnClick) {
        this.showprice = 'none';
      }
      this.menuBtnClick = false;
    });

    this.activeUser = this.authenticationService.get_currentUserValue();

    //  Set Dispositions for Active User
    if (this.activeUser.Portal_SuperAdmin)
      this.despositionArray = AppSettings.dispositionUnpaidAdmin;
    else this.despositionArray = AppSettings.dispositionUnpaid;

    // Get Agents
    this.agentsSub = this.agentsService.agentsS$.subscribe((agents) => {
      if (agents) {
        this.agents = agents.agents;
        console.log('agents', agents);

        this.qa = agents.qa;

        // Set agents for SuperAdmin
        if (this.activeUser.Portal_SuperAdmin) {
          this.select2Agents = [];
          let selectRegion = [
            { label: 'Leads', val: '~' },
            { label: 'Unpaid', val: 'unpaid_~' },
            { label: 'CWHP', val: 'cwhp_~' },
          ];

          for (let i = 0; i < selectRegion.length; i++) {
            for (let j = 0; j < this.agents.length; j++) {
              let agent = $.extend(true, {}, this.agents[j]);
              agent.region = selectRegion[i].label;
              agent.value = selectRegion[i].val + agent.id;
              this.select2Agents.push(agent);
            }
          }
        }
      }
    });

    this.dtOptions = {
      paging: true,
      info: true,
      // ordering: false,
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      searching: false,
      language: AppSettings.dataTableLang,

      columnDefs: [
        { orderable: true, targets: 0 },
        { orderable: true, targets: 1 },
        { orderable: false, targets: 2 },
        { orderable: false, targets: 3 },
        {
          orderable: false,
          visible:
            this.activeUser.Portal_SuperAdmin || this.activeUser.Portal_Sales,
          targets: 4,
        },
        {
          orderable: false,
          visible:
            this.activeUser.Portal_SuperAdmin || this.activeUser.Portal_Sales,
          targets: 5,
        },
        { orderable: false, targets: 6 },
        {
          orderable: false,
          visible: this.activeUser.Portal_SuperAdmin,
          targets: 7,
        },
        { orderable: false, targets: 8 },
        {
          orderable: false,
          visible: this.activeUser.Portal_SuperAdmin,
          targets: 9,
        },
        {
          orderable: false,
          visible:
            this.activeUser.is_qualityassurance || this.activeUser.Portal_Sales,
          targets: 10,
        },
        {
          orderable: false,
          visible: this.activeUser.Portal_Sales,
          targets: 11,
        },
        {
          orderable: false,
          visible: this.activeUser.Portal_Sales && false,
          targets: 12,
        },
        {
          orderable: false,
          visible: this.activeUser.is_qualityassurance,
          targets: 13,
        }, // only show for qa
        { orderable: false, targets: 14 },
      ],
      order: [[0, 'desc']],
      ajax: (dataTablesParameters: any, callback) => {
        // Show Loader
        this.loading = true;
        // console.log("dataTablesParameters", dataTablesParameters);

        let url;
        if (this.activeUser.Portal_SuperAdmin) {
          url = AppSettings.API_ENDPOINT + 'admin/get-unpaid-orders';
        } else if (this.activeUser.Portal_Sales && !this.isMyTab) {
          url = AppSettings.API_ENDPOINT + 'sales/unpaid-orders';
        } else if (this.activeUser.Portal_Sales && this.isMyTab) {
          url = AppSettings.API_ENDPOINT + 'sales/my-unpaid-orders';
        } else if (this.activeUser.is_qualityassurance) {
          url = AppSettings.API_ENDPOINT + 'qa/get-unpaid-orders';
        }

        let dtParams = {
          lead: this.searchParams.emailId,
          disposition:
            this.searchParams.disposition == null
              ? this.searchParams.disposition
              : this.searchParams.disposition.toString(),
          agent_id: this.searchParams.agent_id,
          date_from: this.searchParams.date_from
            ? this.helperService.caonvertDateToString(
                this.searchParams.date_from
              )
            : this.fullRangeDate
            ? this.helperService.caonvertDateToString(this.fullRangeDate[0])
            : '',
          date_to: this.searchParams.date_to
            ? this.helperService.caonvertDateToString(
                this.searchParams.date_to,
                false
              )
            : this.fullRangeDate
            ? this.helperService.caonvertDateToString(
                this.fullRangeDate[1],
                false
              )
            : '',
          work_type:
            this.searchParams.work_type &&
            this.searchParams.work_type.length > 0
              ? this.searchParams.work_type
              : null,
          valid_sales: this.searchParams.valid_sales,
          is_paid: this.searchParams.is_paid,
          order_type: this.searchParams.order_type,
          site_link: this.searchParams.site_link,
          start: dataTablesParameters.start,
          length: dataTablesParameters.length,
          order: dataTablesParameters.order,
          columns: dataTablesParameters.columns,
        };

        // For Record Serial Numbers
        this.paginatePage = dataTablesParameters.start;

        // Empty Data
        this.leads = [];

        this.helperService
          .httpPostRequestsDecryp(url, dtParams)
          .then((resp) => {
            this.leads = JSON.parse(resp);
            // console.log("this.leads",this.leads);
            console.log('this.leads', this.leads);

            this.leads_Copy = $.extend(true, {}, this.leads);

            // Set Default page len
            this.dtOptions.pageLength = this.dtElement['dt'].page.len();
            this.leads.data.forEach((lead: any) => {
              for (let i = 1; i <= 4; i++) {
                const emailStatus = lead[`email${i}_status`];
                const emailDatetime = lead[`email${i}_datetime`];

                if (emailStatus === 0 && emailDatetime !== 'Stopped') {
                  this.initCountdown(emailDatetime, `${lead.id}_${i}`);
                }
              }
            });
            // Hide Loader
            this.loading = false;

            callback({
              recordsTotal: this.leads.total,
              recordsFiltered: this.leads.total,
              // recordsFiltered: resp['recordsFiltered'],
              // recordsFiltered: 1000,
              data: [],
            });

            // // $(".paginate_button .current").css("color", "white");
            // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
            $('div.dataTables_length select').addClass('dt-form-control');
            $('div.dataTables_filter input').addClass('dt-form-control');
          })
          .catch((error) => {
            // Set loader false
            this.loading = false;

            // // Rerender DT in case of failure
            // this.rerender();

            console.log('error: ', error);
          });
      },
      columns: [
        // { data: 'multiDelete' },
        { data: 'id' },
        { data: 'date' },
        { data: 'phoneEmail' },
        { data: 'price_noOfPages' },
        { data: 'academic_level' },
        { data: 'document_type' },
        { data: 'due_date' },
        { data: 'disposition' },
        { data: 'assigned' },
        { data: 'is-paid' },
        { data: 'comments' },
        // { data: 'log' },

        // for sales
        { data: 'comments' },
        { data: 'comments' },
        { data: 'comments' },
        // for qa
        { data: 'comments' },
      ],
      // Use this attribute to enable the responsive extension
      responsive: false,
    };
  }

  ngOnInit() {
    this.addCommentForm = this.formBuilder.group({
      comment: [null, Validators.required],
    });
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  splitFromTo() {
    if (this.fullRangeDate) {
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to = this.fullRangeDate[1];
    }

    this.rerender();
  }

  initCountdown(targetDateStr: string, key: string) {
    const targetDate = new Date(targetDateStr).getTime();

    this.countdowns[key] = ''; // reset first to avoid stale values

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance <= 0) {
        clearInterval(interval);
        this.countdowns[key] = '-';
      } else {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.countdowns[key] = `${days}d ${hours}h ${minutes}m ${seconds}s`;
      }
    }, 1000);
  }

  pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  openMarkHalfFullPay(index) {
    // Show Modal
    $('#mark__half_full_modal_' + index).modal('show');
    $('.modal-backdrop').click(function () {
      $('#mark__half_full_modal_' + index).modal('hide');
    });
  }

  markHalfFullPay(index, lead) {
    // Hide Modal
    $('#mark_full_modal_' + index).modal('hide');

    // Show loader
    this.leads.data[index].updatingHalfPaid = true;

    let url = AppSettings.API_ENDPOINT + 'admin/mark-half-full-paid';
    let data = { id: lead.id };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined' && resp.status == 'OK') {
          if (resp.orderRow) {
            this.leads.data[index].half_price = resp.orderRow.half_price;
            this.leads.data[index].amount = resp.orderRow.amount;
          }

          // Show Action Updated
          let self = this;
          this.leads.data[index].halfUpdated = true;
          setTimeout(() => {
            self.leads.data[index].halfUpdated = false;
          }, 1500);
        }

        // Hide loader
        this.leads.data[index].updatingHalfPaid = false;
      })
      .catch((err) => {
        // Hide loader
        this.leads.data[index].updatingHalfPaid = false;
      });
  }

  editPrice(lead, index) {
    let url = AppSettings.API_ENDPOINT + 'shared/update-price';
    let data = { oid: lead.id, amount: lead.amount };
    this.leads.data[index].priceUpdated = 'show_loader';
    this.helperService.httpPostRequests(url, data).then((resp) => {
      if (typeof resp != 'undefined') {
        this.notesInfo = resp;
        $('#notesModal').modal('hide');
        // Show Action Updated
        let self = this;
        this.leads.data[index].priceUpdated = true;
        setTimeout(() => {
          self.leads.data[index].priceUpdated = false;
        }, 1500);
      }
    });
  }

  showPrice(index) {
    if (this.showprice == index) this.showprice = 'none';
    else this.showprice = index;
  }

  preventCloseOnClick() {
    this.menuBtnClick = true;
  }

  openChangeDesposition(lead, index) {
    this.notes = '';
    this.salesIndex = index;
    this.salesStatusVal = this.leads.data[index].dispostion_id;
    this.submitted = false;

    // Revert to actual until confirmed
    let self = this;
    setTimeout(() => {
      self.leads.data[index].dispostion_id =
        self.leads_Copy.data[index].dispostion_id;
    }, 50);

    // Show loader
    this.leads.data[index].loadingStatusComms = true;

    // Get old Comments
    let url = AppSettings.API_ENDPOINT + 'shared/get-comments';
    let data = { o: lead.id, type: '' };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.comments = resp.data;

          this.leads.data[index].oldComms = [];
          for (let i = 0; i < this.comments.length; i++) {
            if (this.comments[i].type == 'Unpaid-Comments') {
              this.leads.data[index].oldComms.push(this.comments[i]);
            }
          }
        }

        // Show Modal
        $('#commentsLeadsModal' + index).modal('show');
        $('.modal-backdrop').click(function () {
          $('#commentsLeadsModal' + index).modal('hide');
        });

        // Hide loader
        this.leads.data[index].loadingStatusComms = false;
      })
      .catch((err) => {
        // Show Modal
        $('#commentsLeadsModal' + index).modal('show');
        $('.modal-backdrop').click(function () {
          $('#commentsLeadsModal' + index).modal('hide');
        });

        // Hide loader
        this.leads.data[index].loadingStatusComms = false;
      });
  }

  updateDespositionSalesAgent(lead, index) {
    // Set Submission True
    this.submitted = true;

    // Stop here if form is invalid
    if (this.addCommentForm.invalid) {
      return;
    }

    // Show Loader
    this.leads.data[index].loadingWork = true;

    let url = AppSettings.API_ENDPOINT + 'sales/update-unpaid-disposition';
    let data = {
      id: lead.id,
      status: this.salesStatusVal,
      unpaid_comments: this.notes,
    };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined' && resp.status == 'OK') {
          Swal.fire('', resp.message, 'success');
          this.rerender();
        }

        $('#commentsLeadsModal' + index).modal('hide');
        $('.modal-backdrop').remove();

        // Hide Loader
        this.leads.data[index].loadingWork = false;
      })
      .catch((err) => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');

        // Hide Loader
        this.leads.data[index].loadingWork = false;
      });
  }

  openNotesModal(index) {
    this.submitted = false;
    this.notes = '';

    $('#notesModal' + index).modal('show');
  }

  updateSalesSelfNotes(lead, index, type) {
    // Set Submission True
    this.submitted = true;

    // Stop here if form is invalid
    if (this.addCommentForm.invalid) {
      return;
    }

    // Show Loader
    this.loading = true;

    let url =
      AppSettings.API_ENDPOINT + 'sales/update-self-comments-for-unpaid';
    let data = { id: lead.id, comments: this.notes };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.leads.data[index].unpaid_self_comments = this.notes;
          this.notes = '';
          this.cdr.detectChanges();

          $('#notesModal' + index).modal('hide');
          $('.modal-backdrop').remove();

          let self = this;
          this.leads.data[index].noteUpdated = true;
          setTimeout(() => {
            self.leads.data[index].noteUpdated = false;
          }, 1000);
        }

        // Hide Loader
        this.loading = false;
      })
      .catch((err) => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');

        // Hide Loader
        this.loading = false;
      });
  }

  updateDespositionAdmin(lead, index) {
    // Show Loader
    this.leads.data[index].loadingWork = true;

    let url = AppSettings.API_ENDPOINT + 'admin/update-unpaid-disposition';
    let data = {
      id: lead.id,
      status: lead.dispostion_id,
      agent_status: lead.typeSales,
    };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          let self = this;
          this.leads.data[index].actionUpdated = true;
          setTimeout(() => {
            self.leads.data[index].actionUpdated = false;
          }, 1500);
        }

        // Hide Loader
        this.leads.data[index].loadingWork = false;
      })
      .catch((err) => {
        // Hide Loader
        this.leads.data[index].loadingWork = false;
      });
  }

  updateAgent(lead, index) {
    // Show loader
    this.leads.data[index].loadingAgentWork = true;

    let url = AppSettings.API_ENDPOINT + 'admin/update-order-agent';
    let data = { wid: lead.agent_concat_id, oid: lead.id };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined' && resp.status == 'OK') {
          // Set Updated data
          this.leads.data[index].agent = resp.data.agent;
          this.leads.data[index].typeSales = resp.data.typeSales;

          let self = this;
          this.leads.data[index].actionUpdatedA = true;
          setTimeout(() => {
            self.leads.data[index].actionUpdatedA = false;
          }, 1000);
        } else if (typeof resp != 'undefined' && resp.status == 'ERROR') {
          let self = this;
          this.leads.data[index].actionNotUpdated = true;
          setTimeout(() => {
            self.leads.data[index].actionNotUpdated = false;
          }, 1000);
        }

        // Hide loader
        this.leads.data[index].loadingAgentWork = false;
      })
      .catch((err) => {
        // Hide loader
        this.leads.data[index].loadingAgentWork = false;
      });
  }

  showAdminComments(lead, index, type = '') {
    // Show Loader
    this.leads.data[index].loadingComs = true;

    this.agentComments = [];
    this.qaComments = [];
    this.unpaidComments = [];

    let url = AppSettings.API_ENDPOINT + 'shared/get-comments';
    let data = { o: lead.id, type: '' };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.comments = resp.data;

          for (let i = 0; i < this.comments.length; i++) {
            if (this.comments[i].type == 'Unpaid-Comments') {
              this.agentComments.push(this.comments[i]);
            } else if (
              this.comments[i].type == 'QA-Leads-Comments' ||
              this.comments[i].type == 'QA-Comments'
            ) {
              this.qaComments.push(this.comments[i]);
            }
            // else if(this.comments[i].type == "Unpaid-Comments"){
            //   this.unpaidComments.push(this.comments[i]);
            // }
          }

          // Show Modal
          if (this.agentComments.length > 0 || this.qaComments.length > 0) {
            $('#comment_modal' + index).modal('show');
            $('.modal-backdrop').click(function () {
              $('#comment_modal' + index).modal('hide');
            });
          }
        }

        // Hide loader
        this.leads.data[index].loadingComs = false;
      })
      .catch((err) => {
        // Hide loader
        this.leads.data[index].loadingComs = false;
      });
  }

  showComments(lead, index, type = '') {
    // this.loader = true;
    this.submitted = false;
    this.agentComments = [];
    this.qaComments = [];
    this.unpaidComments = [];

    let data = { l: '', o: lead.id, type: '' };
    if (type == 'QA-Leads-Comments') {
      this.qaloader = lead.id;
      data = { o: '', l: lead.id, type: '' };
    } else if (type == 'Unpaid-Comments' || type == 'QA-Comments') {
      // Added for QA Portal loaders
      if (type == 'QA-Comments') {
        this.leads.data[index].loadingComments = true;
      }

      if (type == 'Unpaid-Comments') {
        this.leads.data[index].loadingCommentsAgent = true;
      }

      this.uploader = lead.id;
    } else {
      this.loader = lead.id;
    }

    let url = AppSettings.API_ENDPOINT + 'shared/get-comments';

    this.helperService.httpPostRequests(url, data).then((resp) => {
      if (typeof resp != 'undefined') {
        this.comments = resp.data;

        for (let i = 0; i < this.comments.length; i++) {
          if (this.comments[i].type == 'Leads-Comments') {
            this.agentComments.push(this.comments[i]);
          } else if (
            this.comments[i].type == 'QA-Leads-Comments' ||
            this.comments[i].type == 'QA-Comments'
          ) {
            this.qaComments.push(this.comments[i]);
          } else if (this.comments[i].type == 'Unpaid-Comments') {
            this.unpaidComments.push(this.comments[i]);
          }
        }

        if (type == 'QA-Leads-Comments' || type == 'QA-Comments') {
          if (type == 'QA-Comments') {
            let self = this;
            setTimeout(() => {
              self.leads.data[index].loadingComments = false;
            }, 1000);
          }

          $('#notesModal' + index).modal('show');
        } else {
          if (type == 'Unpaid-Comments') {
            let self = this;
            setTimeout(() => {
              self.leads.data[index].loadingCommentsAgent = false;
            }, 1000);
          }
          if (
            type == '' &&
            this.agentComments.length == 0 &&
            this.qaComments.length == 0
          ) {
            Swal.fire(
              'No comments',
              "Agents and QA haven't added any comments yet.",
              'info'
            );
          } else if (
            (type == 'Leads-Comments' && this.agentComments.length == 0) ||
            (type == 'Unpaid-Comments' && this.unpaidComments.length == 0)
          ) {
            Swal.fire(
              'No comments',
              "Agents haven't added any comments yet.",
              'info'
            );
          } else {
            if (typeof $ != 'undefined') {
              $('#comment_modal' + index).modal('show');
            }
          }
        }

        // Hide loaders
        this.loader = '';
        this.qaloader = '';
        this.uploader = '';

        $('.modal-backdrop').click(function () {
          $('#comment_modal' + index).modal('hide');
        });
      }
    });
  }

  showSalesComments(lead, index, type = '') {
    this.agentComments = [];
    this.qaComments = [];

    // Show Loader
    this.leads.data[index].loadingComms = true;

    let data = { o: lead.id, type: '' };
    let url = AppSettings.API_ENDPOINT + 'shared/get-comments';

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.comments = resp.data;

          for (let i = 0; i < this.comments.length; i++) {
            if (this.comments[i].type == 'Unpaid-Comments') {
              this.agentComments.push(this.comments[i]);
            } else if (
              this.comments[i].type == 'QA-Leads-Comments' ||
              this.comments[i].type == 'QA-Comments'
            ) {
              this.qaComments.push(this.comments[i]);
            }
          }

          if (this.agentComments.length > 0 || this.qaComments.length > 0) {
            $('#comment_modal' + index).modal('show');
            $('.modal-backdrop').click(function () {
              $('#comment_modal' + index).modal('hide');
            });
          }
        }

        // Hide loaders
        this.leads.data[index].loadingComms = false;
      })
      .catch((err) => {
        // Hide loaders
        this.leads.data[index].loadingComms = false;
      });
  }

  get f() {
    return this.addCommentForm.controls;
  }

  addNotes(lead, index, type) {
    // Set Submission True
    this.submitted = true;

    // Stop here if form is invalid
    if (this.addCommentForm.invalid) {
      return;
    }

    this.loading = true;

    let url = AppSettings.API_ENDPOINT + 'shared/insert-note';
    let data = { id: lead.id, note: this.notes, type: 'Unpaid-Comments' };
    if (type == 'QA-Comments') {
      data = { id: lead.id, note: this.notes, type: 'QA-Comments' };
    }

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.notes = '';
          $('#notesModal' + index).modal('hide');
          $('.modal-backdrop').remove();
          Swal.fire('', resp.message, 'success');
        }
        this.loading = false;
        this.rerender();
      })
      .catch((err) => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');

        // Hide Loader
        this.loading = false;
      });
  }

  clearFilters() {
    this.searchParams = {
      emailId: '',
      disposition: null,
      agent_id: [],
      date_from: '',
      date_to: '',
      work_type: null,
      is_paid: null,
    };
    this.fullRangeDate = null;
    this.rerender();
  }

  agentSearch(id, agentArr) {
    console.log('agentArr::', agentArr);
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }

    return '';
  }

  openCheckModal(index) {
    $('#paid_modal_' + index).modal('show');
    $('.modal-backdrop').click(function () {
      $('#paid_modal_' + index).modal('hide');
    });
  }

  updatePaidStatus(lead, status, index) {
    $('#paid_modal_' + index).modal('hide');

    this.leads.data[index].loadingPaidWork = true;
    this.checkedClass = lead.id;

    let url = AppSettings.API_ENDPOINT + 'admin/mark-order-paid';
    let data = { id: lead.id, status: status };

    this.helperService.httpPostRequests(url, data).then((resp) => {
      if (typeof resp != 'undefined') {
        this.leads.data[index].paid = true;
        this.leads.data[index].loadingPaidWork = false;

        let self = this;
        this.leads.data[index].PaidUpdated = true;
        setTimeout(() => {
          self.leads.data[index].PaidUpdated = false;
          self.leads.data.splice(index, 1);
        }, 1000);
      }
    });
  }

  totalPaymentSearch(id, despoArr) {
    for (var i = 0; i < despoArr.length; i++) {
      if (despoArr[i].value === id) {
        return despoArr[i].name;
      }
    }
  }
  // sales portal starts
  openAssignToMe_Sales_Modal(index) {
    this.lead_Index = index;

    // Open Modal
    ($('#sales_assignme_modal' + index) as any).modal('show');
  }

  assignToMe_Sales() {
    // Hide Modal
    ($('#sales_assignme_modal' + this.lead_Index) as any).modal('hide');
    $('.modal-backdrop').remove();

    // Show Status Loader
    this.leads.data[this.lead_Index].loading = true;

    let url = AppSettings.API_ENDPOINT + 'sales/assign-unpaid-order-to-me';
    let data = { id: this.leads.data[this.lead_Index].id, status: 1 };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        // Hide Status Loader
        this.leads.data[this.lead_Index].loading = false;

        if (typeof resp != 'undefined' && resp.status == 'OK') {
          Swal.fire('', resp.message, 'success');

          // Remove lead as its assigned
          this.leads.data.splice(this.lead_Index, 1);
        }
        if (typeof resp != 'undefined' && resp.status == 'ERROR') {
          Swal.fire('', resp.message, 'error');
        }
      })
      .catch((err) => {
        // Hide Status Loader
        this.leads.data[this.lead_Index].loading = false;
        Swal.fire('', 'Something went wrong. Please try again.', 'error');
      });
  }

  // show desposition for unpaid orders

  showDisposition(id, statusArr) {
    for (var i = 0; i < statusArr.length; i++) {
      if (statusArr[i].value === id) {
        return statusArr[i].name;
      }
    }
  }
  // sales portal ends

  orderStatusFilter(id, statusArr) {
    for (var i = 0; i < statusArr.length; i++) {
      if (statusArr[i].value === id) {
        return statusArr[i].name;
      }
    }
  }

  getAgentName(id, statusArr) {
    for (var i = 0; i < statusArr.length; i++) {
      if (statusArr[i].id === id) {
        return statusArr[i].name;
      }
    }
  }

  // switch tab
  switchTab(flag) {
    if (this.isMyTab != flag) {
      this.isMyTab = flag;

      // Hide / Show Columns
      if (this.isMyTab) {
        // Remove the New Lead for My tab
        if (this.despositionArray[0].value == 0) {
          let arr = $.extend(true, [], this.despositionArray);
          this.dispFirstEle = arr.shift();
          this.despositionArray = arr;
        }

        // this.dtOptions.columnDefs[0].visible = false;
        this.dtOptions.columnDefs[10].visible = false;
        this.dtOptions.columnDefs[11].visible = false;
        this.dtOptions.columnDefs[12].visible = true;
      } else {
        // Add the New Lead for Available Tab
        if (this.despositionArray[0].value != 0) {
          let arr = $.extend(true, [], this.despositionArray);
          arr.unshift(this.dispFirstEle);
          this.despositionArray = arr;
        }

        // this.dtOptions.columnDefs[0].visible = true;
        this.dtOptions.columnDefs[10].visible = true;
        this.dtOptions.columnDefs[11].visible = true;
        this.dtOptions.columnDefs[12].visible = false;
      }

      this.cdr.detectChanges();
      this.rerender();
    }
  }

  closeFloatingAlert() {
    this.floatingAlert = false;
  }

  showManyOrder(lead, index, type = '') {
    // this.loader = true;
    this.agentComments = [];
    this.qaComments = [];
    this.loader = lead.id;

    let url =
      AppSettings.API_ENDPOINT + 'shared/get-orders-detail/' + lead.user_id;
    let data = { o: lead.id, type: '' };
    this.helperService.httpPostRequests(url, data).then((resp) => {
      if (typeof resp != 'undefined') {
        this.many_orders_detail = resp.data;
        // console.log('this.many_orders_detail',this.many_orders_detail);

        if (typeof $ != 'undefined') {
          $('#many_order_modal' + index).modal('show');
        }

        // Hide loaders
        this.loader = '';

        $('.modal-backdrop').click(function () {
          $('#many_order_modal' + index).modal('hide');
        });
      }
    });
  }
}
